import * as Yup from 'yup';

export const TrackingSchema = Yup.object({
  sending_tracking: Yup.boolean(),
  enable_logic_panel: Yup.boolean(),
  total_send_email: Yup.number().nullable(),
  emails_tracking: Yup.string()
    .nullable()
    .transform(value => (value === null || value?.trim() === '' ? null : value))
    .when('sending_tracking', {
      is: true,
      then: s =>
        s.required('Informe um email para receber tracking')
          .test('emails-validation', function (value) {
            if (!value) {
              return this.createError({ message: 'Informe um email para receber tracking' });
            }

            const invalidSeparators = /[;#|\/\\\t\n]/;
            if (invalidSeparators.test(value)) {
              return this.createError({ message: 'Os emails devem ser separados por vírgula' });
            }

            if (/,,|^,|,$| ,|, /.test(value)) {
              return this.createError({ message: 'Os emails devem ser separados por vírgula' });
            }

            const emails = value.split(',').map(e => e.trim()).filter(Boolean);

            if (emails.length > 20) {
              return this.createError({ message: 'Você pode informar no máximo 20 emails' });
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const invalid = emails.find(e => !emailRegex.test(e));
            if (invalid) {
              return this.createError({ message: 'Um ou mais emails são inválidos' });
            }

            return true;
          }),
      otherwise: s => s.notRequired().nullable(),
    }),
  cost_centers: Yup.array().when('sending_tracking', {
    is: true,
    then: s =>
      s
        .of(Yup.number().required('Centro de custo inválido'))
        .min(1, 'Selecione pelo menos um centro de custo'),
    otherwise: s => s.notRequired().nullable(),
  }),

  total_send_email: Yup.number().when('sending_tracking', {
    is: true,
    then: schema =>
      schema
        .required('Informe o total de envios diários'),
    otherwise: schema => schema.notRequired().nullable(),
  }),


  time_interval: Yup.array().when(['sending_tracking', 'total_send_email'], {
    is: (sending_tracking, total_send_email) =>
      sending_tracking === true &&
      (total_send_email !== false || total_send_email !== null),
    then: s =>
      s
        .of(
          Yup.string()
            .matches(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, 'Formato de hora inválido')
            .required('Informe o horário')
        )
        .min(1, 'Informe pelo menos um horário'),
    otherwise: s => s.notRequired().nullable(),
  }),
});




export async function validate(data, setErrors) {
  const errorList = {};
  try {

    await TrackingSchema.validate(data, {
      abortEarly: false,
    });

    return true;
  } catch (err) {
    if (err.inner) {
      err.inner.forEach(error => {
        errorList[error.path] = error?.message;
      });
    }
    return false;
  } finally {
    setErrors(errorList);
  }
}
